import { jsx as s } from "react/jsx-runtime";
import { O as e } from "./ODSGlobalHeader.3SI5uG6R.js";
const l = (r) => {
  const { children: o, logoProps: a, ...t } = r;
  return /* @__PURE__ */ s(e, { variant: "standard", logoProps: a, ...t, children: o });
};
export {
  l as O
};
//# sourceMappingURL=ODSStandardGlobalHeader._k3szGRx.js.map
